import React, { useRef, useEffect, useState } from 'react';
import classNames from 'classnames';
import AliceCarousel from 'react-alice-carousel';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import {
  DraftContent,
  AspectRatioWrapper,
  ResponsiveImage,
  Button,
  IconCarouselArrows,
  IconArrowHead,
  MasonryPopup
} from '../../components';

import css from './ListingPage.module.css';

const MODAL_BREAKPOINT = 768;

const SectionFoodAndStayGallery = props => {
  const { name, title, description, publicData, locale, listing, onManageDisableScrolling } = props;
  const secondaryImagesIds = publicData?.secondaryImagesIds || [];

  if (!description && !secondaryImagesIds?.length) return null;

  const [showSection, setShowSection] = useState(true);

  const isWindowDefined = typeof window !== 'undefined';
  const isMobileLayout = isWindowDefined && window.innerWidth < MODAL_BREAKPOINT;
  const [realIndex, setRealIndex] = useState(0);
  const [internalIndex, setInternalIndex] = useState(0);
  const carouselRef = useRef(null);

  const listingImages = listing?.images;
  const secondaryImages = listingImages?.filter(img => secondaryImagesIds.includes(img.id.uuid))

  const imageSizesMaybe = { sizes: `(max-width: 1024px) 100vw, (max-width: 1200px) calc(100vw - 192px), 708px` };
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];


  const carouselItems = secondaryImages?.map(item => {
    return (
      <AspectRatioWrapper
        width={1}
        height={1}
        className={css.itemWrapper}
      >
        <div className={css.itemCentering}>
          <ResponsiveImage
            rootClassName={css.item}
            image={item}
            variants={imageVariants}
            {...imageSizesMaybe}
          />
        </div>
      </AspectRatioWrapper>
    );
  });

  const prevButton = () => (
    <button className={css.prevButton} type="button">
      <IconCarouselArrows type="black-left" />
    </button>
  );

  const nextButton = () => (
    <button className={css.nextButton} type="button">
      <IconCarouselArrows type="black-right" />
    </button>
  );

  const itemsCount = carouselItems?.length;
  const showFullCarousel = itemsCount >= 3;
  const itemsToShow = 3;

  const goTo = (targetReal) => {
    if (!carouselRef.current) return;
    const currentInternal = internalIndex;
    const currentReal = realIndex;
    const deltaForward = (targetReal - currentReal + itemsCount) % itemsCount;
    const deltaBackward = (currentReal - targetReal + itemsCount) % itemsCount;
    const moveBy = deltaForward <= deltaBackward ? deltaForward : -deltaBackward;
    const newInternal = currentInternal + moveBy;

    carouselRef.current?.slideTo(newInternal);
  };

  return (
    <section className={css.section}>
      <h2 className={css.sectionTitle} onClick={() => setShowSection(!showSection)}>
        {title}
        <IconArrowHead direction={showSection ? "up" : "down"} />
      </h2>
      {showSection && (
        <>
          {description && <DraftContent draftContent={description} />}

          {!!secondaryImages?.length && (
            <div className={classNames(css.carouselHolder, showFullCarousel && css.carouselHolderWithArrows)}>
              <AliceCarousel
                className={css.listingsCarousel}
                ref={carouselRef}
                slideBy={1}
                disableDotsControls
                infinite={showFullCarousel}
                items={carouselItems}
                responsive={{
                  0: { items: 1 },
                  860: { items: Math.min(itemsCount, 2), itemsFit: 'contain' },
                  1024: {
                    items: showFullCarousel ? 2 : itemsToShow,
                    itemsFit: 'contain',
                  },
                  1280: {
                    items: showFullCarousel ? 3 : itemsToShow,
                    itemsFit: 'contain',
                  },
                }}
                renderPrevButton={showFullCarousel ? prevButton : () => null}
                renderNextButton={showFullCarousel ? nextButton : () => null}
                onSlideChanged={({ item }) => {
                  setInternalIndex(item);
                  setRealIndex(((item % itemsCount) + itemsCount) % itemsCount);
                }}
              />
              <div className={css.customDots}>
                {carouselItems.map((_, i) => (
                  <button
                    key={i}
                    className={classNames(css.dot, { [css.dotActive]: i === realIndex })}
                    onClick={() => goTo(i)}
                  />
                ))}
              </div>

              <div className={css.showAllImagesHolder}>
                <MasonryPopup
                  id="secondaryImagesGallery"
                  items={secondaryImages}
                  buttonClass={css.showAllImages}
                  buttonText={<FormattedMessage id="ListingPage.viewInGallery" />}
                  onManageDisableScrolling={onManageDisableScrolling}
                />
              </div>
            </div>
          )}
        </>
      )}
    </section>
  );
};

export default SectionFoodAndStayGallery;
